import React from 'react';
import PropTypes from 'prop-types';
import DefaultPlaceholder from './default_placeholder';
import { randomString } from 'lib/string_utils';

import './index.scss';

export default class GoogleTranslate extends React.Component {
  static displayName = 'GoogleTranslate';
  static propTypes = {
    placeholder: PropTypes.node,
    defaultPlaceholderText: PropTypes.string,
    enabled: PropTypes.bool,
  };

  static defaultProps = {
    enabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      enabled: this.props.enabled,
    };
  }

  componentDidMount() {
    this.uniqueId = randomString(5);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.googleTranslateLoaded && !prevState.googleTranslateLoaded) {
      new google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
          multilanguagePage: true,
        },
        this.elementId()
      );
    }
  }

  initCallbackName() {
    return `googleTranslateCallback_${this.uniqueId}`;
  }

  elementId() {
    return `google_translate_element_${this.uniqueId}`;
  }

  scriptSrc() {
    return `//translate.google.com/translate_a/element.js?cb=${this.initCallbackName()}`;
  }

  injectGoogleTranslateScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = this.scriptSrc();
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  googleTranslateInitCallback() {
    this.setState({ googleTranslateLoaded: true });
  }

  createGoogleTranslateInitCallback() {
    window[this.initCallbackName()] =
      this.googleTranslateInitCallback.bind(this);
  }

  enableTranslate() {
    this.createGoogleTranslateInitCallback();
    this.injectGoogleTranslateScript();
    this.setState({ enabled: true });
  }

  renderDefaultPlaceholder() {
    return <DefaultPlaceholder text={this.props.defaultPlaceholderText} />;
  }

  renderPlaceholder() {
    const placeholder =
      this.props.placeholder || this.renderDefaultPlaceholder();
    return (
      <div
        className="GoogleTranslate-Placeholder"
        onClick={this.enableTranslate.bind(this)}
      >
        {placeholder}
      </div>
    );
  }

  renderTranslate() {
    return <div id={this.elementId()} className="GoogleTranslate-element" />;
  }

  render() {
    return (
      <div className="GoogleTranslate">
        {this.state.enabled ? this.renderTranslate() : this.renderPlaceholder()}
      </div>
    );
  }
}
